import faqEs from './faqEs';
import headerEs from './headerEs';
import footerEs from './footerEs';
import homeEs from './homeEs';
import prescriptiondiscountEs from './prescriptiondiscountEs';
import loginEs from './loginEs';
import membercenterEs from './membercenterEs';
import accountsettingEs from './accountsettingEs';
import bonussavingFAQES from './bonussavingFAQEs';
import howitworksEs from './howitworksEs';
import aboutusEs from './aboutusEs';
import browseprescriptionEs from './browseprescriptionEs';
import signupEs from './signupEs';
import drugpopupEs from './drugpopupEs';
import prescriptionEs from './prescriptionEs/prescriptionEs';
import priceAleartEs from './prescriptionEs/priceAleartEs';
import couponModalEs from './prescriptionEs/couponModalEs';
import pfizerModalEs from './prescriptionEs/pfizerModalEs';
import constantEs from './contantEs';
import drugbasketEs from './drugbasketEs';
import prescriptionDeliveryEs from './prescriptionDeliveryEs';
import discountSavingsSectionEs from './discountSavingsSectionEs';
import specialtydrugEs from './specialtydrugEs';
import forgotPasswordEs from './forgotPasswordEs';
import authenticatemodalEs from './authenticatemodalEs';
import enterpasswordmodalEs from './enterpasswordmodalEs';
import signuphomedeliveryEs from './signuphomedeliveryEs';
import emailsentmodalEs from './emailsentmodalEs';
import notFoundEs from './notFoundEs';
import altTextEs from './altTextEs';
import singlecareEs from './singlecareappEs.json';
import FamilywizeFaqEs from './FamilywizeFaqEs';
import conditionsES from './conditionsES.json';
import partnersEs from './partnersEs.json';
import medicareEs from './medicareEs.json';
import referralSuccessEs from './referralSuccessEs.json';
import deleteAccountEs from './deleteAccountEs.json';
import signupLandingEs from './signupLandingEs.json';
import homeNewEs from './homeNewEs.json';
import factCheckModalEs from './FactCheckModalEs.json';
import washingtonPrivacyPolicyEs from './washingtonPrivacyPolicyEs.json';

export const translationES = {
  'applies to any eligible offer below':
    'se aplica a cualquier oferta elegible a continuación',
  'You have': 'Tienes',
  'in bonus savings': 'en ahorros de bonificación',
  'available.': '.',
  'Type your drug name': 'Ingresa el nombre de tu medicamento',
  'ada suggestion drug message':
    'Las sugerencias están disponibles. Usa las teclas de flecha arriba y abajo para navegar por las sugerencias automáticas.',
  Search: 'Buscar',
  'Oops, there are no results for the term':
    '¡Vaya!, no hay resultados para el término de búsqueda ',
  'Enter zip': 'Ingresa tu código postal',
  in: 'en',
  ...faqEs,
  ...headerEs,
  ...footerEs,
  ...homeEs,
  ...prescriptiondiscountEs,
  ...loginEs,
  ...membercenterEs,
  ...accountsettingEs,
  ...bonussavingFAQES,
  ...howitworksEs,
  ...aboutusEs,
  ...browseprescriptionEs,
  ...signupEs,
  ...prescriptionEs,
  ...constantEs,
  ...priceAleartEs,
  ...couponModalEs,
  ...pfizerModalEs,
  ...drugpopupEs,
  ...browseprescriptionEs,
  ...drugbasketEs,
  ...prescriptionDeliveryEs,
  ...discountSavingsSectionEs,
  ...specialtydrugEs,
  ...forgotPasswordEs,
  ...authenticatemodalEs,
  ...enterpasswordmodalEs,
  ...signuphomedeliveryEs,
  ...emailsentmodalEs,
  ...notFoundEs,
  ...altTextEs,
  ...singlecareEs,
  ...FamilywizeFaqEs,
  ...conditionsES,
  ...partnersEs,
  ...medicareEs,
  ...referralSuccessEs,
  ...deleteAccountEs,
  ...signupLandingEs,
  ...homeNewEs,
  ...factCheckModalEs,
  ...washingtonPrivacyPolicyEs
};
